import axiosInstance from '@/plugins/axios';

const ServiceHome = {
  // GET /home/resumo -> { empresas, reprocessamentosAtivos, pendencias, certidoesOkPercentual }
  resumo: () => axiosInstance.get('home/resumo'),
};

export default ServiceHome;
